export default {
  masterChef: {
    97: '0x1d32c2945C8FDCBc7156c553B7cEa4325a17f4f9',
    92522: '0x6f74A6E495d5528a0026ebC6230e2eBB232D2f09',
  },
  sousChef: {
    97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    92522: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  lotteryV2: {
    97: '0x5790c3534F30437641541a0FA04C992799602998',
    92522: '0x667665f8f1777022372E0cF5FE5DfbfF2A193409',
  },
  multiCall: {
    92522: '0xf0F80C9fA32DcE1bA3Baf60E3697E3542044dE8c',
    97: '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
  },
  pancakeProfile: {
    92522: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeRabbits: {
    92522: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    92522: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    92522: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '',
  },
  pointCenterIfo: {
    92522: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
 
  bunnySpecial: {
    92522: '0xFee8A195570a18461146F401d6033f5ab3380849',
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetition: {
    92522: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    97: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  easterNft: {
    92522: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    97: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  IfoV4: {
    92522: '0xD725b91904571AF9924C8Cab7446B5Ac3F2C0b8F',
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  cakeVault: {
    92522: '0x59212Bc3A8C04Dca95C7DFBc0f97d7368AC77262',
    97: '',
  },
  Launchpadv1: {
    92522: '0x316C78885A183E0cFF5C4DFE437Ef050C47FA1cd',
    96: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  predictions: {
    92522: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    97: '',
  },
  chainlinkOracle: {
    92522: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    97: '',
  },
  bunnySpecialCakeVault: {
    92522: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    97: '',
  },
  bunnySpecialPrediction: {
    92522: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    97: '',
  },
  bunnySpecialLottery: {
    92522: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    97: '0x382cB497110F398F0f152cae82821476AE51c9cF',
  },
  farmAuction: {
    92522: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    97: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },
  AnniversaryAchievement: {
    92522: '0x787980da5491118C3cB33B21aB50c8c379D2C552',
    97: '0x981aE96378e770DE44F89cD9175E708f9EDB70a9',
  },
  nftMarket: {
    92522: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    97: '0x7f9f37ddcaa33893f9beb3d8748c8d6bfbde6ab2',
  },
  nftSale: {
    92522: '0x29fE7148636b7Ae0b1E53777b28dfbaA9327af8E',
    97: '0xe486De509c5381cbdBF3e71F57D7F1f7570f5c46',
  },
  pancakeSquad: {
    92522: '0x0a8901b0E25DEb55A87524f0cC164E9644020EBA',
    97: '0xfC0c3F11fDA72Cb9A56F28Ec8D44C0ae4B3ABF86',
  },
  nft: { // NFT
    92522: "0x843A26c7642769E106aa140f10f58162701031d2",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0x8f251FBFf8e3b5FE0093ae7DFFCE82Ea513B775e', // '0xD41d1b9072E4918d617dB6e7BF8D30FD77dec586',
    56: '0x5CF4890E08f50Dbc80A8A67FadbD5517922B2C37',
    5: '0x856C6dee77f88Df74F61afbB86c2C2BeEE44deCD',
    4: '0xd753294Cc2F2be848C1cfAAffceEB2F4d7899B1f',
    1: '0x1fc6B3f9225b84111c7F5aEF0291b01A35b15731',
  },
  staking: { // NFT Staking
    92522: "0x843A26c7642769E106aa140f10f58162701031d2",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0x704698E3571C29083d8B5595939b0D8e193fb9D9', // '0x028105B7B930427B3c4D84519e1d6Dac465b4c3D',
    56: '0x36000E261Ad3fD443bc557020130FE09f905d9cb',
    5: '0x9797c9cd77D41a7F894600e83886c92CB2C2F49F',
    4: '0x0E6D4f98eD5549bd3570fb7E59Bf6Bea8Fe246F4',
    1: '0xcAfB5890A55cF9F315E4B865C190F1c3b5ab6854',
  },
  reward: { // Reward Token
    92522: "0x843A26c7642769E106aa140f10f58162701031d2",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0x6e58aEFCbA76a6BCa4695264380BD589a3e838B3', // '0xb59A7147291248bdAaC5Bb754c702f5e18588A67',
    56: '0x39f2dB46AF00cdd849fd0014e20fa562669A9EcD',
    5: '0xA792e10f63BC3557A0443E09e45599e2Db726d9F',
    4: '0x032DAeAcf1Dbe5D72e6Fe5ECe055b7b4C4577c8F',
    1: '0x48426C719AE9A29aF00553B2ac72173D89Cc93f6',
  },
  marketplace: { // Reward Token
    92522: "0x843A26c7642769E106aa140f10f58162701031d2",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0xea3064b7aA485E999Cd6D5783578125525493B40',
    80001: '0xb42eae772a860e95698cfaa939e2c50c9bab771b',
    97: '0x6e58aEFCbA76a6BCa4695264380BD589a3e838B3', // '0xb59A7147291248bdAaC5Bb754c702f5e18588A67',
    56: '0x39f2dB46AF00cdd849fd0014e20fa562669A9EcD',
    5: '0xA792e10f63BC3557A0443E09e45599e2Db726d9F',
    4: '0x032DAeAcf1Dbe5D72e6Fe5ECe055b7b4C4577c8F',
    1: '0x48426C719AE9A29aF00553B2ac72173D89Cc93f6',
  },
  multicall1: {
    92522: "0x843A26c7642769E106aa140f10f58162701031d2",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0x60194b3eDF9b95A6087FE1940275AE7036641dd8',
    56: '0xa63B2b296A3c42C7EbFDC64a9B05f20A7361D5dd',
    5: '0xdb6F81301a14f6060B46f4ea4EB2748C543A2408',
    4: '0x477975206744De34bE580AA5Efb4576011E8d232',
    1: '0x94f05e6869f26FC202797a68642d7500A9551288',
  },
  multicall2: {
    92522: "0x843A26c7642769E106aa140f10f58162701031d2",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0xC67F4B3fe070A5F18c519a5c70819017D01021f4',
    56: '0xa63B2b296A3c42C7EbFDC64a9B05f20A7361D5dd',
    5: '0xdb6F81301a14f6060B46f4ea4EB2748C543A2408',
    4: '0x477975206744De34bE580AA5Efb4576011E8d232',
    1: '0x94f05e6869f26FC202797a68642d7500A9551288',
  },
  multicall3: {
    92522: "0x843A26c7642769E106aa140f10f58162701031d2",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0x4cbb8205923E455f4659462C59eb44417BEF57F6',
    56: '0xa63B2b296A3c42C7EbFDC64a9B05f20A7361D5dd',
    5: '0xdb6F81301a14f6060B46f4ea4EB2748C543A2408',
    4: '0x477975206744De34bE580AA5Efb4576011E8d232',
    1: '0x94f05e6869f26FC202797a68642d7500A9551288',
  },
  register: {
    92522: "0x843A26c7642769E106aa140f10f58162701031d2",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0x92e9D7Da7F781E1B6FdA00feD0bD33B73B446667', // '0x1C85321c96FF240A89F6724CA4943a90383Ae634',
    56: '0xeCbd00f8274Af7b0023075CB1633bE750e6d6c06',
    5: '0xBdF6522d451f0000076f44dc72ebAcCD37aE3373',
    4: '0xea6E393474a1DBdC4422D3c4Aed6B77E47A4B585',
    1: '0xeCbd00f8274Af7b0023075CB1633bE750e6d6c06',
  },
  pancakeRouter: {
    92522: "0x843A26c7642769E106aa140f10f58162701031d2",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1',
    56: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
    5: '0xd753294Cc2F2be848C1cfAAffceEB2F4d7899B1f',
    4: '0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45',
    1: '0xeCbd00f8274Af7b0023075CB1633bE750e6d6c06',
  },
  WBMB: {
    92522: "0x2AEF6E68f93517829A0E5B3a8932E59A305c1F63",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    5: '0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6',
    4: '0xc778417E063141139Fce010982780140Aa0cD5Ab',
    1: '0xeCbd00f8274Af7b0023075CB1633bE750e6d6c06',
  },
  USDT: {
    92522: "0x2AEF6E68f93517829A0E5B3a8932E59A305c1F63",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    5: '0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6',
    4: '0xc778417E063141139Fce010982780140Aa0cD5Ab',
    1: '0xeCbd00f8274Af7b0023075CB1633bE750e6d6c06',
  },
  PRICE_FEED: {
    92522: "0x2AEF6E68f93517829A0E5B3a8932E59A305c1F63",
    197978: '0xc139D6223040a3435a1112A96f5666ba57F02DDa',
    1978: '0x6C62e7DcF386ED53e00CbC01BD3f74D920fdD15C',
    80001: '0xFBE40EAc2f627Dd78c07Aa4d5E3c22b3F9B99eB4',
    97: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    5: '0xD4a33860578De61DBAbDc8BFdb98FD742fA7028e',
    4: '0xc778417E063141139Fce010982780140Aa0cD5Ab',
    1: '0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419',
  },
}
